<template>
  <b-table
    :data="jobs"
    striped
    paginated
    hoverable
    :loading="isLoading"
    backend-sorting
    backend-pagination
    :total="total"
    :per-page="query.limit"
    :current-page="currentPage"
    @page-change="onPageChange">

    <template v-slot="{ row }">
      <slot :row="row"/>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon
              icon="emoticon-sad"
              size="is-large">
            </b-icon>
          </p>
          <p>No results found.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>

export default {
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
    endPoint: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
      total: null,
      jobs: [],
    };
  },
  computed: {
    currentPage() {
      return Math.ceil(this.query.offset / this.query.limit) + 1;
    },
  },
  methods: {
    async onPageChange(p) {
      window.scrollTo(0, 0);
      this.$emit('pageChange', p);
    },
    async getResults() {
      const response = (await this.$http.get(this.endPoint, { params: this.query })).data;
      this.jobs = response.results;
      this.total = response.count;
      this.isLoading = false;
    },
  },
  watch: {
    query: {
      async handler() {
        this.getResults();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
